import React, { useRef, useEffect } from 'react';
import { Polyline, withLeaflet } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-polylinedecorator';

const PolylineDecorator = withLeaflet(props => {
  const polyRef = useRef();

  useEffect(() => {
    const polyline = polyRef.current.leafletElement;
    const { map } = polyRef.current.props.leaflet;

    L.polylineDecorator(polyline, {
      patterns : props.patterns
    }).addTo(map);
  }, []);

  return <Polyline ref={polyRef} {...props} />;
});

export default PolylineDecorator;
